export default __webpack_public_path__ + "static/media/auth-pattern.d80b0e94.svg";